import { Search } from '@mui/icons-material';
import { Fab, Tooltip, useTheme } from '@mui/material';
import { FC } from 'react';

type SearchBlocksButton = {
  onClick: () => void;
};

const SearchBlocksButton: FC<SearchBlocksButton> = (props) => {
  const theme = useTheme();

  return (
    <Tooltip title='Search...' placement='left'>
      <Fab
        size='medium'
        color='primary'
        onClick={props.onClick}
        sx={{
          position: 'absolute',
          bottom: theme.spacing(10),
          right: theme.spacing(2)
        }}
      >
        <Search />
      </Fab>
    </Tooltip>
  );
};

export default SearchBlocksButton;
